<template>
  <login-modal-shell
    v-model="isOpen"
    :is-mobile="isMobile"
    :modal-class="newclass"
    @show="clearAndReset(false, true)"
    @hide="
      $emit('close-modal'),
        clearAndReset(true, false),
        clearResumeClinic(),
        $store.commit('userVUEX/setProfileProgress', false)
    "
  >
    <!-- Mobile View -->
    <div v-if="isMobile" class="mobile-login-screen">
      <!-- Top header area with wave background -->
      <div
        class="mobile-header-panel"
        :class="{ 'business-header-bg': userType === 'admin' }"
      >
        <div class="header-back-wrapper">
          <img
            src="../../assets/imgs/newhomepage/round-right-iconB.svg"
            class="header-back-icon"
            alt="Back"
            @click="isOpen = false"
          />
        </div>

        <div class="logo-text-wrapper text-center">
          <!-- hire3xround-logo -->
          <img
            src="@/assets/imgs/newhomepage/hire3x-round-logo.svg"
            class="hire3x-round-logo mb-3"
            alt="Logo"
          />

          <h2
            class="mobile-header-title"
            :class="{ 'business-title': userType === 'admin' }"
          >
            {{
              userType === "admin"
                ? "Smarter screening. Faster hiring."
                : "Don’t Just Work. Build a Career You Love."
            }}
          </h2>
          <p class="mobile-header-subtitle">
            Sign up to find the next big opportunity
          </p>
        </div>
      </div>

      <!-- Bottom Card Panel -->
      <b-overlay
        :show="show"
        :opacity="overlayOpacity"
        rounded="sm"
        class="mobile-overlay-wrapper"
      >
        <template #overlay>
          <div class="overlaybox">
            <b-spinner class="login-loader"></b-spinner>
            <span class="overlaytxt">{{ loaderLabel }}</span>
          </div>
        </template>

        <div
          class="mobile-form-panel"
          :class="{ 'set-password-padding': setPasswordMode }"
        >
          <template v-if="!setPasswordMode">
            <!-- Candidate / Business Segment Control -->
            <div class="mob-toggle-container mb-4">
              <div class="mob-toggle-track d-flex w-100">
                <button
                  class="mob-toggle-btn flex-fill"
                  :class="{ active: userType === 'candidate' }"
                  @click="userType = 'candidate'"
                >
                  Candidate
                </button>
                <button
                  class="mob-toggle-btn flex-fill"
                  :class="{ active: userType === 'admin' }"
                  @click="userType = 'admin'"
                >
                  Business
                </button>
              </div>
            </div>

            <!-- Google SSO (Candidate only) -->
            <template v-if="userType === 'candidate'">
              <!-- Google SSO (Candidate only) -->
              <div class="mb-4">
                <b-button
                  variant="outline-light"
                  block
                  class="mob-google-btn"
                  @click="googleLogin('newlogin')"
                >
                  <img
                    src="@/assets/imgs/Builderpage/onboarding/google.svg"
                    height="20"
                    class="mr-2"
                    alt="Google"
                  />
                  Login with Google
                </b-button>
                <div class="invalid-msg-txt mt-2" v-if="invalidCredential && !otpSent && !setPasswordMode">
                  {{ invalidText }}
                </div>
              </div>

              <div class="mob-separator mb-4">
                <span>Sign up / Login with</span>
              </div>

              <!-- Input Field Container -->
              <div class="mb-4">
                <!-- Identifier input (phone or email) -->
                <div>
                  <!-- Phone Number Input -->
                  <div v-if="!useEmail">
                    <PhoneNumber
                      ref="candphone"
                      modelKey="number"
                      :modelValue="loginPhone"
                      :countryCode="loginPhoneCountryCode"
                      @countrycode="loginPhoneCountryCode = $event"
                      :error="loginPhoneInvalid && !otpSent"
                      :disabled="otpSent"
                      :showEdit="otpSent"
                      @edit="handleEdit()"
                      @phonevalidation="handlePhoneValidation($event)"
                      @enter-phone="handleSubmit()"
                    />
                    <div
                      class="invalid-msg-txt mt-1"
                      v-if="loginPhoneInvalid && !otpSent"
                    >
                      Invalid Phone Number
                    </div>
                    <div
                      class="invalid-msg-txt mt-1"
                      v-if="sendOtpError && !useEmail && !otpExceeded"
                    >
                      {{ sendOtpError }}
                    </div>

                    <div v-if="!otpSent" class="text-right mt-2">
                      <a
                        href="javascript:void(0)"
                        @click="toggleLoginMode(true)"
                        class="mob-toggle-link"
                      >
                        Use E-mail ID instead
                      </a>
                    </div>
                  </div>

                  <!-- Email Input -->
                  <div v-else>
                    <div class="position-relative">
                      <b-form-input
                        v-model="$v.email.$model"
                        @keydown.space.prevent
                        ref="candmail"
                        @keypress.enter="handleSubmit()"
                        type="email"
                        placeholder="Enter Email ID"
                        class="single-field-update"
                        :class="{
                          error:
                            $v.email.$error || (sendOtpError && !otpExceeded),
                        }"
                        :disabled="otpSent"
                      ></b-form-input>
                      <a
                        v-if="otpSent"
                        href="javascript:void(0)"
                        @click="handleEdit()"
                        class="dummy-edit-btn mob-email-edit-overlay"
                        >Edit</a
                      >
                    </div>
                    <div
                      class="invalid-msg-txt mt-1"
                      v-if="$v.email.$error && !otpSent"
                    >
                      {{
                        $v.email.$dirty && !$v.email.required
                          ? "Required"
                          : $v.email.required &&
                            (!$v.email.email || !$v.email.alphaEmail)
                          ? "Invalid Email"
                          : !$v.email.maxLength
                          ? "Should not execed 64 characters"
                          : ""
                      }}
                    </div>
                    <div
                      class="invalid-msg-txt mt-1"
                      v-if="sendOtpError && useEmail && !otpExceeded"
                    >
                      {{ sendOtpError }}
                    </div>

                    <div v-if="!otpSent" class="text-right mt-2">
                      <a
                        href="javascript:void(0)"
                        @click="toggleLoginMode(false)"
                        class="mob-toggle-link"
                      >
                        Use Phone Number instead
                      </a>
                    </div>
                  </div>
                </div>

                <!-- Case 2: OTP has been sent (show OTP input / Password input) -->
                <div v-if="otpSent">
                  <!-- Enter OTP Field -->
                  <div v-if="useOtp">
                    <b-form-input
                      v-model.trim="otpCode"
                      placeholder="Enter OTP"
                      class="single-field-update mt-3"
                      maxlength="6"
                      :class="{
                        error: $v.otpCode.$error || invalidCredential,
                      }"
                      @keypress="otpNumbersOnly"
                    ></b-form-input>
                    <div class="invalid-msg-txt mt-1" v-if="$v.otpCode.$error">
                      {{
                        !$v.otpCode.required
                          ? "Required"
                          : "Please enter a valid OTP"
                      }}
                    </div>
                    <div
                      class="invalid-msg-txt mt-1"
                      v-else-if="invalidCredential && !setPasswordMode"
                    >
                      {{ invalidText }}
                    </div>

                    <!-- Links under Enter OTP -->
                    <div
                      :class="
                        userExists !== null
                          ? 'justify-content-between'
                          : 'justify-content-end'
                      "
                      class="d-flex align-items-center mt-3"
                      style="
                        font-family: 'Inter', sans-serif !important;
                        font-size: 12px !important;
                      "
                    >
                      <!-- Left slot: always present so Resend stays right -->
                      <div>
                        <a
                          v-if="userExists === false"
                          href="javascript:void(0)"
                          @click="openPasswordSetup()"
                          style="
                            color: #4a7eff !important;
                            font-weight: 500 !important;
                            text-decoration: underline !important;
                          "
                        >
                          Set password to sign up
                        </a>
                        <a
                          v-else-if="userExists === true"
                          href="javascript:void(0)"
                          @click="usePasswordOrSetup()"
                          style="
                            color: #4a7eff !important;
                            font-weight: 500 !important;
                            text-decoration: underline !important;
                          "
                        >
                          Use password
                        </a>
                      </div>

                      <!-- Right Timer / Resend Link -->
                      <span
                        v-if="timerOut"
                        style="
                          color: #4a7eff !important;
                          font-weight: 500 !important;
                        "
                      >
                        {{
                          otpExceeded
                            ? "OTP already sent. Resend in"
                            : "Resend in"
                        }}
                        <span style="font-weight: 600 !important">{{
                          formattedTime
                        }}</span>
                      </span>
                      <a
                        v-else
                        href="javascript:void(0)"
                        @click="register('resend')"
                        style="
                          color: #4a7eff !important;
                          font-weight: 500 !important;
                          text-decoration: underline !important;
                        "
                      >
                        Resend OTP
                      </a>
                    </div>
                  </div>

                  <!-- Enter Password Field -->
                  <div v-else>
                    <div class="position-relative mt-3">
                      <b-form-input
                        v-model="$v.password.$model"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Enter Password"
                        class="single-field-update"
                        :class="{ error: $v.password.$error }"
                        @input="$v.password.$touch()"
                      ></b-form-input>
                      <span
                        class="password-toggle-icon"
                        @click="showPassword = !showPassword"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          v-if="!showPassword"
                        >
                          <path
                            d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                            stroke="#999"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <circle
                            cx="12"
                            cy="12"
                            r="3"
                            stroke="#999"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          v-else
                        >
                          <path
                            d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
                            stroke="#999"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </div>

                    <div class="invalid-msg-txt mt-1" v-if="$v.password.$error">
                      {{
                        $v.password.$dirty && !$v.password.required
                          ? "Required"
                          : !$v.password.maxLength && $v.password.required
                          ? "Should not execed 55 characters"
                          : ""
                      }}
                    </div>
                    <div
                      class="invalid-msg-txt mt-1"
                      v-else-if="invalidCredential"
                    >
                      {{ invalidText }}
                    </div>

                    <!-- Links under Enter Password -->
                    <div
                      class="d-flex justify-content-between align-items-center mt-3"
                      style="
                        font-family: 'Inter', sans-serif !important;
                        font-size: 12px !important;
                      "
                    >
                      <a
                        href="javascript:void(0)"
                        @click="useOtpLogin()"
                        style="
                          color: #4a7eff !important;
                          font-weight: 600 !important;
                          text-decoration: underline !important;
                        "
                      >
                        Login with OTP
                      </a>
                      <a
                        href="javascript:void(0)"
                        @click.stop.prevent="openPasswordSetup(true)"
                        style="
                          color: #333333 !important;
                          font-weight: 500 !important;
                          text-decoration: none !important;
                        "
                      >
                        Forgot Password?
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Continue Button -->
              <b-button
                variant="primary"
                @click="handleSubmit()"
                block
                class="mob-continue-btn mb-4"
                :disabled="
                  userType === 'candidate' &&
                  useOtp &&
                  !otpSent &&
                  (useEmail
                    ? !email || email.trim() === ''
                    : !loginPhone.number || loginPhone.number.trim() === '')
                "
              >
                {{
                  userType === "candidate" && useOtp
                    ? !otpSent
                      ? "Continue with OTP"
                      : userExists === false
                      ? "Sign up"
                      : "Login"
                    : "Login"
                }}
              </b-button>

              <!-- Terms Disclaimer -->
              <div class="mob-terms-container text-center">
                <p class="mob-terms-text">
                  By Continuing, you accept to the
                  <a
                    href="javascript:void(0)"
                    @click="terms()"
                    class="mob-terms-link"
                    >Terms and Conditions</a
                  >
                  and
                  <a
                    href="javascript:void(0)"
                    @click="goToPrivacyPolicy()"
                    class="mob-terms-link"
                    >Privacy Policy</a
                  >
                  of Hire3x.com
                </p>
              </div>
            </template>

            <!-- business section mobile -->
            <template v-else-if="userType === 'admin'">
              <!-- login business mobile -->
              <template v-if="mode === 'login'">
                <div class="mb-3">
                  <b-form-input
                    v-model="$v.email.$model"
                    @keydown.space.prevent
                    ref="candmail"
                    @keypress.enter="handleSubmit()"
                    type="email"
                    placeholder="Email"
                    class="single-field-update"
                    :class="{ error: $v.email.$error }"
                  ></b-form-input>
                  <div class="invalid-msg-txt mt-1" v-if="$v.email.$error">
                    {{
                      $v.email.$dirty && !$v.email.required
                        ? "Required"
                        : $v.email.required &&
                          (!$v.email.email || !$v.email.alphaEmail)
                        ? "Invalid Email"
                        : !$v.email.maxLength
                        ? "Should not execed 64 characters"
                        : ""
                    }}
                  </div>
                </div>
                <div class="mb-3">
                  <div class="position-relative">
                    <b-form-input
                      v-model="$v.password.$model"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="Password"
                      class="single-field-update password-input"
                      ref="candpass"
                      @keypress.enter="handleSubmit()"
                      autocomplete="off"
                      :class="{ error: $v.password.$error }"
                      @input="$v.password.$touch()"
                    ></b-form-input>
                    <span
                      class="password-toggle-icon"
                      @click="showPassword = !showPassword"
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        v-if="!showPassword"
                      >
                        <path
                          d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                          stroke="#999"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <circle
                          cx="12"
                          cy="12"
                          r="3"
                          stroke="#999"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        v-else
                      >
                        <path
                          d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
                          stroke="#999"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div class="invalid-msg-txt mt-1" v-if="$v.password.$error">
                    {{
                      $v.password.$dirty && !$v.password.required
                        ? "Required"
                        : !$v.password.maxLength && $v.password.required
                        ? "Should not execed 55 characters"
                        : ""
                    }}
                  </div>

                  <div
                    class="invalid-msg-txt mt-1"
                    v-else-if="invalidCredential"
                  >
                    {{ invalidText }}
                  </div>
                </div>
                <div class="text-left mb-4">
                  <a
                    href="javascript:void(0)"
                    class="forgot-link"
                    @click="mode = 'forgot'"
                    >Forgot your password?</a
                  >
                </div>

                <b-button
                  variant="primary"
                  @click="handleSubmit()"
                  block
                  class="login-submit-btn mb-3"
                >
                  Login
                </b-button>
                <div class="text-center">
                  <p class="signup-text font-inter">
                    Don't have an account yet?
                    <a @click="goToDemo()" class="register-link pointer"
                      >Request Demo</a
                    >
                  </p>
                </div>
              </template>
              <!-- Forgot Password View Mobile -->
              <div v-if="mode === 'forgot'" class="forgot d-flex flex-column">
                <hr
                  id="hideinmobile"
                  style="border-top: 1px solid #dee2e6"
                  class="mb-4 mt-4"
                />
                <h3 class="font-inter fw-600 color-darkblack mb-2 fs-22">
                  Forgot Passwords?
                </h3>
                <p class="font-inter color-gray mb-4 fs-14">
                  Enter the email address associated with this account.
                </p>

                <div class="mb-4">
                  <b-form-input
                    type="email"
                    placeholder="Email"
                    class="login-input"
                    v-model="$v.email.$model"
                    @keydown.space.prevent
                    ref="candmail"
                    @keypress.enter="forgotPassword()"
                    :class="{ error: $v.email.$error || invalidCredential }"
                  ></b-form-input>
                  <div
                    class="invalid-msg-txt"
                    v-if="$v.email.$error || invalidCredential"
                  >
                    {{
                      $v.email.$dirty && !$v.email.required
                        ? "Required"
                        : $v.email.required &&
                          (!$v.email.email || !$v.email.alphaEmail)
                        ? "Invalid Email"
                        : !$v.email.maxLength
                        ? "Should not execed 64 characters"
                        : invalidCredential
                        ? invalidText
                        : ""
                    }}
                  </div>
                </div>

                <b-button
                  @click="forgotPassword()"
                  variant="primary"
                  block
                  class="login-submit-btn mb-4"
                >
                  Send OTP
                </b-button>

                <div class="text-center mt-2">
                  <a
                    href="javascript:void(0)"
                    @click="mode = 'login'"
                    class="back-to-login font-inter fw-500 color-blue text-decoration-none"
                  >
                    <i class="fas fa-arrow-left mr-1"></i> Back to login
                  </a>
                </div>
              </div>

              <!-- Verify OTP View Mobile -->
              <div
                v-if="
                  (mode === 'otp' || mode === 'forgotOtp') &&
                  userType !== 'candidate'
                "
                class="forgotOtp d-flex flex-column"
              >
                <hr
                  id="hideinmobile"
                  style="border-top: 1px solid #dee2e6"
                  class="mb-4 mt-4"
                />
                <h3 class="font-inter fw-600 color-darkblack mb-2 fs-22">
                  Verify OTP
                </h3>
                <p class="font-inter color-gray mb-4 fs-14">
                  Please enter the 6 digits OTP sent to :-
                  <a
                    href="javascript:void(0)"
                    class="color-blue text-decoration-none"
                  >
                    {{ formatEmail }}</a
                  >
                </p>

                <div
                  class="d-flex otp-input-row justify-content-between"
                  :class="
                    invalidCredential ||
                    ($v.otpDigits.$dirty && $v.otpDigits.$invalid && verifyotp)
                      ? 'mb-1'
                      : 'mb-4'
                  "
                >
                  <input
                    ref="firstInput"
                    type="number"
                    :class="{
                      error:
                        invalidCredential ||
                        ($v.otpDigits.num1.$error && verifyotp),
                    }"
                    maxlength="1"
                    placeholder="0"
                    @keydown="moveToNextField($event, 'secondInput', null)"
                    @keypress="restrictToOneDigit"
                    class="otp-box no-number"
                    v-model="$v.otpDigits.num1.$model"
                  />
                  <input
                    ref="secondInput"
                    type="number"
                    :class="{
                      error:
                        invalidCredential ||
                        ($v.otpDigits.num2.$error && verifyotp),
                    }"
                    @keydown="
                      moveToNextField($event, 'thirdInput', 'firstInput')
                    "
                    @keypress="restrictToOneDigit"
                    @paste="preventPaste"
                    placeholder="0"
                    maxlength="1"
                    class="otp-box no-number"
                    v-model="$v.otpDigits.num2.$model"
                  />
                  <input
                    ref="thirdInput"
                    type="number"
                    :class="{
                      error:
                        invalidCredential ||
                        ($v.otpDigits.num3.$error && verifyotp),
                    }"
                    @keydown="
                      moveToNextField($event, 'fourthInput', 'secondInput')
                    "
                    @keypress="restrictToOneDigit"
                    @paste="preventPaste"
                    placeholder="0"
                    maxlength="1"
                    class="otp-box no-number"
                    v-model="$v.otpDigits.num3.$model"
                  />
                  <input
                    ref="fourthInput"
                    type="number"
                    :class="{
                      error:
                        invalidCredential ||
                        ($v.otpDigits.num4.$error && verifyotp),
                    }"
                    @keydown="
                      moveToNextField($event, 'fifthInput', 'thirdInput')
                    "
                    @keypress="restrictToOneDigit"
                    @paste="preventPaste"
                    placeholder="0"
                    maxlength="1"
                    class="otp-box no-number"
                    v-model="$v.otpDigits.num4.$model"
                  />
                  <input
                    ref="fifthInput"
                    type="number"
                    :class="{
                      error:
                        invalidCredential ||
                        ($v.otpDigits.num5.$error && verifyotp),
                    }"
                    @keydown="
                      moveToNextField($event, 'sixthInput', 'fourthInput')
                    "
                    @keypress="restrictToOneDigit"
                    @paste="preventPaste"
                    placeholder="0"
                    maxlength="1"
                    class="otp-box no-number"
                    v-model="$v.otpDigits.num5.$model"
                  />
                  <input
                    ref="sixthInput"
                    type="number"
                    :class="{
                      error:
                        invalidCredential ||
                        ($v.otpDigits.num6.$error && verifyotp),
                    }"
                    @keypress="restrictToOneDigit"
                    @keypress.enter="
                      mode === 'otp' ? handleSubmit() : resetPasswordOTP()
                    "
                    @keydown="moveToNextField($event, null, 'fifthInput')"
                    @paste="preventPaste"
                    placeholder="0"
                    maxlength="1"
                    class="otp-box no-number"
                    v-model="$v.otpDigits.num6.$model"
                  />
                </div>

                <div
                  class="invalid-msg-txt"
                  v-if="
                    invalidCredential ||
                    ($v.otpDigits.$dirty && $v.otpDigits.$invalid && verifyotp)
                  "
                >
                  {{ invalidCredential ? invalidText : "Enter a valid otp" }}
                </div>

                <template v-if="!otpExceeded">
                  <div class="text-left mb-4">
                    <span class="font-inter fs-13 color-gray"
                      >Didn't receive code?
                    </span>
                    <span v-if="timerOut" class="font-inter fs-13 color-gray">
                      Resend in
                      <span
                        class="fw-500 fs-13 text-decoration-none"
                        style="color: red"
                        >{{ formattedTime }}</span
                      >
                    </span>
                    <a
                      v-else
                      href="javascript:void(0)"
                      @click="
                        !isResetPasswordMode
                          ? forgotPassword('resendotp')
                          : register('resend')
                      "
                      class="color-blue fw-500 text-decoration-none"
                      >Resend OTP</a
                    >
                  </div>
                </template>
                <div v-else class="text-left mb-4">
                  <span class="fam-inter fs-13 color-gray"
                    >OTP has already been sent.<br v-if="isMobile" />
                    You can request a new OTP in
                  </span>
                  <span
                    class="fw-500 fs-13 text-decoration-none"
                    style="color: red"
                    >{{ formattedTime }}</span
                  >
                </div>

                <b-button
                  @click="mode === 'otp' ? handleSubmit() : resetPasswordOTP()"
                  variant="primary"
                  block
                  class="login-submit-btn mb-4"
                >
                  Verify
                </b-button>

                <div class="text-center mt-2">
                  <a
                    href="javascript:void(0)"
                    @click="mode = 'login'"
                    class="back-to-login font-inter fw-500 color-blue text-decoration-none"
                  >
                    <i class="fas fa-arrow-left mr-1"></i> Back to login
                  </a>
                </div>
              </div>
              <!-- Reset Password View Web -->
              <div v-if="mode === 'reset'" class="reset d-flex flex-column">
                <hr
                  id="hideinmobile"
                  style="border-top: 1px solid #dee2e6"
                  class="mb-4 mt-4"
                />
                <h3 class="font-inter fw-600 color-darkblack mb-2 fs-22">
                  Reset Password
                </h3>
                <p class="font-inter color-gray mb-4 fs-14">
                  Please enter the new password to reset your password.
                </p>
                <div class="mb-3">
                  <div class="position-relative">
                    <b-form-input
                      :type="showPass ? 'text' : 'password'"
                      @input="validatePassword('rePassword')"
                      v-model="$v.rePassword.$model"
                      ref="passnew"
                      placeholder="New Password"
                      class="login-input single-field-update pr-5"
                      @keypress.enter="resetPasswordAdmin()"
                      :class="{
                        error: $v.rePassword.$error || checkpassowrdInvalid,
                      }"
                    ></b-form-input>
                    <span
                      class="password-toggle-icon"
                      @click="showPass = !showPass"
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        v-if="!showPass"
                      >
                        <path
                          d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                          stroke="#999"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <circle
                          cx="12"
                          cy="12"
                          r="3"
                          stroke="#999"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        v-else
                      >
                        <path
                          d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
                          stroke="#999"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div
                    class="invalid-msg-txt"
                    v-if="$v.rePassword.$error || checkpassowrdInvalid"
                  >
                    {{
                      $v.rePassword.$dirty && !$v.rePassword.required
                        ? "Required"
                        : checkpassowrdInvalid
                        ? passwordValidation
                        : !$v.rePassword.maxLength && $v.rePassword.required
                        ? "Should not exceed 55 characters"
                        : ""
                    }}
                  </div>
                </div>
                <div class="mb-4 position-relative">
                  <b-form-input
                    type="password"
                    @paste="preventPaste"
                    ref="pass"
                    v-model="$v.reConfirmpassword.$model"
                    @keypress.enter="resetPasswordAdmin()"
                    :class="{
                      error: $v.reConfirmpassword.$error || match,
                    }"
                    placeholder="Confirm Password"
                    class="login-input pr-5 single-field-update"
                  ></b-form-input>
                  <div
                    class="invalid-msg-txt"
                    v-if="$v.reConfirmpassword.$error || match"
                  >
                    {{
                      $v.reConfirmpassword.$dirty &&
                      !$v.reConfirmpassword.required
                        ? "Required"
                        : !$v.reConfirmpassword.maxLength &&
                          $v.reConfirmpassword.required
                        ? "Should not exceed 55 characters"
                        : match
                        ? "Password mismatch"
                        : ""
                    }}
                  </div>
                </div>

                <!-- OTP field — visible only after passwords are validated and OTP sent -->
                <div v-if="showSetPasswordOtp" class="mb-2">
                  <b-form-input
                    v-model.trim="otpCode"
                    type="text"
                    placeholder="Enter OTP"
                    class="login-input single-field-update"
                    maxlength="6"
                    @keypress="otpNumbersOnly"
                    @keypress.enter="resetPasswordAdmin()"
                    :class="{ error: $v.otpCode.$error || invalidCredential }"
                  ></b-form-input>
                  <div class="invalid-msg-txt mt-1" v-if="$v.otpCode.$error">
                    {{
                      !$v.otpCode.required
                        ? "Required"
                        : "Please enter a valid OTP"
                    }}
                  </div>
                  <div
                    class="invalid-msg-txt mt-1"
                    v-else-if="invalidCredential"
                  >
                    {{ invalidText }}
                  </div>
                </div>
                <!-- Resend OTP row -->
                <div
                  v-if="showSetPasswordOtp"
                  class="d-flex justify-content-end mb-3"
                >
                  <span
                    v-if="timerOut"
                    style="font-size: 13px; color: #4a7eff; font-weight: 500"
                  >
                    {{
                      otpExceeded ? "OTP already sent. Resend in" : "Resend in"
                    }}
                    <span style="font-weight: 600">{{ formattedTime }}</span>
                  </span>
                  <a
                    v-else
                    href="javascript:void(0)"
                    @click="
                      isResetPasswordMode
                        ? forgotPassword('resend')
                        : register('resend')
                    "
                    style="font-size: 13px; color: #4a7eff; font-weight: 500"
                    >Resend OTP</a
                  >
                </div>

                <b-button
                  @click="resetPasswordAdmin()"
                  variant="primary"
                  block
                  class="login-submit-btn mb-4"
                >
                  Reset Password
                </b-button>

                <div class="text-center mt-2">
                  <a
                    href="javascript:void(0)"
                    @click="mode = 'login'"
                    class="back-to-login font-inter fw-500 color-blue text-decoration-none"
                  >
                    <i class="fas fa-arrow-left mr-1"></i> Back to login
                  </a>
                </div>
              </div>
            </template>
          </template>

          <!-- Set Password Flow for Mobile -->
          <template v-else>
            <div class="mobile-set-password-container">
              <h3 class="mobile-set-password-title">
                {{
                  isNewUserPasswordSetup
                    ? "Set Password"
                    : isResetPasswordMode
                    ? "Reset Password"
                    : "Set Password"
                }}
              </h3>
              <p class="mobile-set-password-subtitle">
                Securely activate your account password to be more secure
              </p>

              <!-- Sent Info Box with Envelope icon -->
              <div class="mob-sent-info-box mb-4">
                <div
                  class="d-flex justify-content-between align-items-center w-100"
                >
                  <div>
                    <span class="mob-sent-label">OTP Sent on</span>
                    <div class="d-flex align-items-center mt-2">
                      <img
                        v-if="useEmail"
                        src="@/assets/imgs/newhomepage/tabler_mail.svg"
                        width="20"
                        height="20"
                        class="mr-2 mail-icon"
                        alt="Mail"
                      />
                      <img
                        v-else
                        src="@/assets/imgs/newhomepage/solar_phone-outline.svg"
                        width="20"
                        height="20"
                        class="mr-2 mail-icon"
                        alt="Phone"
                      />
                      <span class="mob-sent-email">
                        {{
                          useEmail
                            ? email
                            : (loginPhoneCountryCode.startsWith("+")
                                ? loginPhoneCountryCode
                                : "+" + loginPhoneCountryCode) +
                              "-" +
                              loginPhone.number
                        }}
                      </span>
                    </div>
                  </div>
                  <a
                    href="javascript:void(0)"
                    @click="handleIdentifierEdit()"
                    class="mob-sent-edit-btn"
                    >Edit</a
                  >
                </div>
              </div>

              <!-- Input Fields -->
              <div class="mobile-fields-container">
                <div class="mb-3">
                  <div class="position-relative">
                    <b-form-input
                      ref="setPassField"
                      v-model="$v.setPassword.$model"
                      @input="validatePassword('setPassword')"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="Enter Password"
                      class="single-field-update"
                      :class="{
                        error: $v.setPassword.$error || checkpassowrdInvalid,
                      }"
                    ></b-form-input>
                    <span
                      class="password-toggle-icon"
                      @click="showPassword = !showPassword"
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        v-if="!showPassword"
                      >
                        <path
                          d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                          stroke="#999"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <circle
                          cx="12"
                          cy="12"
                          r="3"
                          stroke="#999"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        v-else
                      >
                        <path
                          d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
                          stroke="#999"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div
                    class="invalid-msg-txt mt-1"
                    v-if="$v.setPassword.$error || checkpassowrdInvalid"
                  >
                    {{
                      !$v.setPassword.required
                        ? "Required"
                        : checkpassowrdInvalid
                        ? passwordValidation
                        : !$v.setPassword.maxLength
                        ? "Should not exceed 55 characters"
                        : ""
                    }}
                  </div>
                </div>

                <b-form-input
                  ref="confirmPassField"
                  v-model="$v.confirmPassword.$model"
                  type="password"
                  placeholder="Confirm Password"
                  class="single-field-update"
                  :class="{ error: $v.confirmPassword.$error || match }"
                ></b-form-input>
                <div
                  class="invalid-msg-txt mt-1"
                  v-if="$v.confirmPassword.$error"
                >
                  {{
                    !$v.confirmPassword.required
                      ? "Required"
                      : !$v.confirmPassword.maxLength
                      ? "Should not exceed 55 characters"
                      : ""
                  }}
                </div>
                <div class="invalid-msg-txt mt-1" v-else-if="match">
                  Passwords do not match
                </div>
              </div>

              <!-- Enter OTP field for mobile Set Password -->
              <div class="mt-3">
                <b-form-input
                  ref="candotp"
                  v-model.trim="$v.otpCode.$model"
                  placeholder="Enter OTP"
                  class="single-field-update"
                  maxlength="6"
                  :class="{ error: $v.otpCode.$error || invalidCredential }"
                  @keypress="otpNumbersOnly"
                ></b-form-input>
                <div class="invalid-msg-txt mt-1" v-if="$v.otpCode.$error">
                  {{
                    !$v.otpCode.required
                      ? "Required"
                      : "Please enter a valid OTP"
                  }}
                </div>
                <div class="invalid-msg-txt mt-1" v-else-if="invalidCredential">
                  {{ invalidText }}
                </div>

                <div class="text-right mt-2" style="font-size: 13px">
                  <span v-if="timerOut" style="color: #667085">
                    {{
                      otpExceeded
                        ? "OTP has already been sent."
                        : "Didn't receive the OTP yet?"
                    }}
                    <span style="color: #28a745; font-weight: 500"
                      >Resend in {{ formattedTime }}</span
                    >
                  </span>
                  <a
                    v-else
                    href="javascript:void(0)"
                    @click="
                      isResetPasswordMode || isNewUserPasswordSetup
                        ? forgotPassword('resend')
                        : register('resend')
                    "
                    style="color: #4a7eff; font-weight: 500"
                    >Resend OTP</a
                  >
                </div>
              </div>

              <!-- Reset Password Button -->
              <b-button
                @click="handleSubmit()"
                variant="primary"
                block
                class="mob-continue-btn mt-4"
              >
                {{
                  isNewUserPasswordSetup
                    ? "LogIn"
                    : isResetPasswordMode
                    ? "Reset Password"
                    : "Confirm & Login"
                }}
              </b-button>
            </div>
          </template>
          <Popupcomponent
            v-if="showPopup || registered"
            :showPopup="showPopup"
            :registered="registered"
            :candExists="candExists"
            :invalidText="invalidText"
            :successText="successText"
          />
        </div>
      </b-overlay>
    </div>

    <!-- Desktop View -->
    <div v-else class="login-modal-container">
      <!-- Close Button -->
      <button class="close-modal-btn" @click="isOpen = false">
        <span>✕</span>
      </button>

      <div class="row no-gutters">
        <!-- Left Side: Content Box -->
        <div class="col-lg-5 d-none d-lg-block left-panel">
          <div class="left-content h-100 d-flex flex-column">
            <!-- Business Side: Stable image -->
            <div
              v-if="userType === 'admin'"
              class="illustration-placeholder mt-auto position-relative flex-grow-1 overflow-hidden"
            >
              <img
                src="@/assets/imgs/newhomepage/wave-boy.png"
                class="character-img h-100 position-absolute"
                alt="Login illustration"
              />
            </div>

            <!-- Candidate Side: Carousel slider -->
            <template v-else>
              <div
                class="illustration-placeholder mt-auto position-relative flex-grow-1 overflow-hidden"
              >
                <transition-group name="fade" tag="div" class="h-100">
                  <img
                    v-for="(img, index) in sliderImages"
                    :key="'img-' + index"
                    v-show="sliderIndex === index"
                    :src="img"
                    class="character-img h-100 position-absolute"
                    alt="Login illustration"
                  />
                </transition-group>
              </div>
              <!-- Slider dots -->
              <div class="slider-dots-container mb-4">
                <div class="slider-dots d-flex justify-content-center">
                  <span
                    v-for="(dot, index) in sliderImages"
                    :key="'dot-' + index"
                    class="dot"
                    :class="{ active: sliderIndex === index }"
                    @click="setSlide(index)"
                  ></span>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- Right Side: Form Content -->
        <div class="col-lg-7 col-12 right-panel">
          <!-- Login View -->
          <div v-if="mode === 'login'" class="login-form-wrapper">
            <b-overlay
              :show="show"
              :opacity="overlayOpacity"
              rounded="sm"
              class="h-100"
            >
              <template #overlay>
                <div class="overlaybox">
                  <b-spinner class="login-loader"></b-spinner>
                  <span class="overlaytxt">{{ loaderLabel }}</span>
                </div>
              </template>

              <div v-if="!setPasswordMode">
                <!-- Toggle Switch -->
                <div class="toggle-container">
                  <div class="toggle-track d-flex w-100">
                    <button
                      class="flex-fill toggle-btn"
                      :class="{ active: userType === 'candidate' }"
                      @click="userType = 'candidate'"
                    >
                      Candidate
                    </button>
                    <button
                      class="flex-fill toggle-btn"
                      :class="{ active: userType === 'admin' }"
                      @click="userType = 'admin'"
                    >
                      Business
                    </button>
                  </div>
                </div>
              </div>
              <div v-else-if="setPasswordMode" class="pr-3 mb-3">
                <h3 class="mb-2 mobile-set-password-title">
                  {{
                    isNewUserPasswordSetup
                      ? "Set Password"
                      : isResetPasswordMode
                      ? "Reset Password"
                      : "Set Password"
                  }}
                </h3>
                <p class="mobile-set-password-subtitle">
                  Securely activate your account password to be more secure
                </p>
              </div>

              <div
                class="login-overflow"
                :class="{ 'has-errors': hasSetPasswordErrors }"
              >
                <div v-if="!setPasswordMode">
                  <!-- Google SSO (Candidate only) -->
                  <template v-if="userType === 'candidate'">
                    <b-button
                      variant="outline-light"
                      block
                      class="google-login-btn"
                      @click="googleLogin('newlogin')"
                    >
                      <img
                        src="@/assets/imgs/Builderpage/onboarding/google.svg"
                        height="20"
                        class="mr-2"
                        alt="Google"
                      />
                      Login with Google
                    </b-button>
                    <div class="invalid-msg-txt mt-2" v-if="invalidCredential && !otpSent && !setPasswordMode">
                      {{ invalidText }}
                    </div>
                    <div class="separator mt-4 mb-4">
                      <span>Sign up / Login with</span>
                    </div>
                  </template>
                </div>

                <!-- Inputs -->
                <template v-if="userType === 'candidate'">
                  <div class="mb-4">
                    <!-- Phone Input -->
                    <!-- Set Password Section -->
                    <div v-if="setPasswordMode" class="set-password-container">
                      <div>
                        <!-- Rounded Info Box (background gradient) -->
                        <div class="otp-sent-info-box mb-4">
                          <div
                            class="d-flex justify-content-between align-items-center"
                          >
                            <div>
                              <span class="info-box-label">OTP Sent on</span>
                              <div class="d-flex align-items-center mt-2">
                                <!-- Mail Icon -->
                                <img
                                  v-if="useEmail"
                                  src="@/assets/imgs/newhomepage/tabler_mail.svg"
                                  width="24"
                                  height="24"
                                  class="mr-2"
                                  alt="Mail"
                                />
                                <!-- Phone Icon -->
                                <img
                                  v-else
                                  src="@/assets/imgs/newhomepage/solar_phone-outline.svg"
                                  width="24"
                                  height="24"
                                  class="mr-2"
                                  alt="Phone"
                                />

                                <span class="info-box-value">
                                  {{
                                    useEmail
                                      ? email
                                      : (loginPhoneCountryCode.startsWith("+")
                                          ? loginPhoneCountryCode
                                          : "+" + loginPhoneCountryCode) +
                                        "-" +
                                        loginPhone.number
                                  }}
                                </span>
                              </div>
                            </div>
                            <a
                              href="javascript:void(0)"
                              @click="handleIdentifierEdit()"
                              class="info-box-edit-link"
                              >Edit</a
                            >
                          </div>
                        </div>

                        <div style="margin-top: 24px !important">
                          <div class="mb-4">
                            <div class="position-relative">
                              <b-form-input
                                ref="setPassField"
                                v-model="$v.setPassword.$model"
                                @input="validatePassword('setPassword')"
                                :type="showSetPassword ? 'text' : 'password'"
                                placeholder="Enter Password"
                                class="login-input single-field-update"
                                style="margin-top: 0px !important"
                                :class="{
                                  error:
                                    $v.setPassword.$error ||
                                    checkpassowrdInvalid,
                                }"
                              ></b-form-input>
                              <span
                                class="password-toggle-icon"
                                @click="showSetPassword = !showSetPassword"
                                style="
                                  right: 24px;
                                  top: 50%;
                                  transform: translateY(-50%);
                                "
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  v-if="!showSetPassword"
                                >
                                  <path
                                    d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                    stroke="#999"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="3"
                                    stroke="#999"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  v-else
                                >
                                  <path
                                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
                                    stroke="#999"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </span>
                            </div>
                            <div
                              class="invalid-msg-txt mt-1"
                              v-if="
                                $v.setPassword.$error || checkpassowrdInvalid
                              "
                            >
                              {{
                                !$v.setPassword.required
                                  ? "Required"
                                  : checkpassowrdInvalid
                                  ? passwordValidation
                                  : !$v.setPassword.maxLength
                                  ? "Should not exceed 55 characters"
                                  : ""
                              }}
                            </div>
                          </div>
                          <div class="mb-4">
                            <b-form-input
                              ref="confirmPassField"
                              v-model="$v.confirmPassword.$model"
                              type="password"
                              placeholder="Confirm Password"
                              class="login-input single-field-update"
                              :class="{
                                error: $v.confirmPassword.$error || match,
                              }"
                            ></b-form-input>
                            <div
                              class="invalid-msg-txt mt-1"
                              v-if="$v.confirmPassword.$error"
                            >
                              {{
                                !$v.confirmPassword.required
                                  ? "Required"
                                  : !$v.confirmPassword.maxLength
                                  ? "Should not exceed 55 characters"
                                  : ""
                              }}
                            </div>
                            <div class="invalid-msg-txt mt-1" v-else-if="match">
                              Passwords do not match
                            </div>
                          </div>
                          <!-- Enter OTP field for web Set Password -->
                          <div class="mb-4">
                            <b-form-input
                              ref="candotp"
                              v-model.trim="$v.otpCode.$model"
                              type="text"
                              placeholder="Enter OTP"
                              class="single-field-update"
                              maxlength="6"
                              @keypress.enter="handleSubmit()"
                              :class="{
                                error: $v.otpCode.$error || invalidCredential,
                              }"
                              @keypress="otpNumbersOnly"
                            ></b-form-input>
                            <div
                              class="invalid-msg-txt mt-1"
                              v-if="$v.otpCode.$error"
                            >
                              Please enter a valid OTP
                            </div>
                            <div
                              class="invalid-msg-txt mt-1"
                              v-else-if="invalidCredential"
                            >
                              {{ invalidText }}
                            </div>

                            <div
                              class="text-right mt-2"
                              style="font-size: 13px"
                            >
                              <span v-if="timerOut" style="color: #667085">
                                {{
                                  otpExceeded
                                    ? "OTP has already been sent."
                                    : "Didn't receive the OTP yet?"
                                }}
                                <span style="color: #28a745; font-weight: 500"
                                  >Resend in {{ formattedTime }}</span
                                >
                              </span>
                              <a
                                v-else
                                href="javascript:void(0)"
                                @click="
                                  isResetPasswordMode
                                    ? forgotPassword('resend')
                                    : register('resend')
                                "
                                style="color: #4a7eff; font-weight: 500"
                                >Resend OTP</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <b-button
                        @click="handleSubmit()"
                        variant="primary"
                        block
                        class="login-submit-btn"
                        style="background-color: #4a7eff !important"
                      >
                        {{
                          isResetPasswordMode
                            ? "Reset Password"
                            : "Confirm & Login"
                        }}
                      </b-button>
                    </div>

                    <!-- Normal Candidate Phone Login Form -->
                    <div v-else-if="!useEmail">
                      <PhoneNumber
                        ref="candphone"
                        modelKey="number"
                        :modelValue="loginPhone"
                        :countryCode="loginPhoneCountryCode"
                        @countrycode="loginPhoneCountryCode = $event"
                        :error="loginPhoneInvalid && !otpSent"
                        :disabled="otpSent"
                        :showEdit="otpSent"
                        @edit="handleIdentifierEdit()"
                        @phonevalidation="handlePhoneValidation($event)"
                        @enter-phone="handleSubmit()"
                      />
                      <div
                        class="invalid-msg-txt mt-1"
                        v-if="loginPhoneInvalid && !otpSent"
                      >
                        Invalid Phone Number
                      </div>
                      <div
                        class="invalid-msg-txt mt-1"
                        v-if="sendOtpError && !useEmail && !otpExceeded"
                      >
                        {{ sendOtpError }}
                      </div>
                      <div v-if="!otpSent" class="text-right mt-2 mb-3">
                        <a
                          href="javascript:void(0)"
                          @click="toggleLoginMode(true)"
                          class="toggle-input-link"
                        >
                          Use E-mail ID instead
                        </a>
                      </div>

                      <!-- OTP Field (placed after phone number field) -->
                      <div v-if="useOtp && otpSent" class="mt-3">
                        <b-form-input
                          ref="candotp"
                          v-model.trim="otpCode"
                          type="text"
                          placeholder="Enter OTP"
                          class="single-field-update"
                          maxlength="6"
                          @keypress.enter="handleSubmit()"
                          :class="{
                            error: $v.otpCode.$error || invalidCredential,
                          }"
                          @keypress="otpNumbersOnly"
                        ></b-form-input>
                        <div
                          class="invalid-msg-txt mt-1"
                          v-if="$v.otpCode.$error"
                        >
                          {{
                            !$v.otpCode.required
                              ? "Required"
                              : "Please enter a valid OTP"
                          }}
                        </div>
                        <div
                          class="invalid-msg-txt mt-1"
                          v-else-if="invalidCredential && !setPasswordMode"
                        >
                          {{ invalidText }}
                        </div>
                      </div>

                      <!-- Password Field (if they choose to use password) -->
                      <div v-if="!useOtp" class="mt-3 position-relative">
                        <b-form-input
                          v-model="$v.password.$model"
                          :type="showPassword ? 'text' : 'password'"
                          placeholder="Enter Password"
                          class="login-input single-field-update"
                          ref="candpass"
                          @keypress.enter="handleSubmit()"
                          autocomplete="off"
                          :class="{ error: $v.password.$error }"
                        ></b-form-input>
                        <span
                          class="password-toggle-icon"
                          @click="showPassword = !showPassword"
                          style="right: 24px"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            v-if="!showPassword"
                          >
                            <path
                              d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                              stroke="#999"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle
                              cx="12"
                              cy="12"
                              r="3"
                              stroke="#999"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            v-else
                          >
                            <path
                              d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
                              stroke="#999"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      <div
                        class="invalid-msg-txt mt-1"
                        v-if="!useOtp && $v.password.$error"
                      >
                        {{
                          $v.password.$dirty && !$v.password.required
                            ? "Required"
                            : !$v.password.maxLength && $v.password.required
                            ? "Should not execed 55 characters"
                            : ""
                        }}
                      </div>
                      <div
                        class="invalid-msg-txt mt-1"
                        v-else-if="!useOtp && invalidCredential"
                      >
                        {{ invalidText }}
                      </div>

                      <!-- Links under the input -->
                      <!-- Case 1: When showing OTP -->
                      <div
                        :class="
                          userExists !== null
                            ? 'justify-content-between'
                            : 'justify-content-end'
                        "
                        v-if="useOtp && otpSent"
                        class="d-flex align-items-center otp-links-container"
                      >
                        <!-- Left: Set password / Use password links -->
                        <a
                          v-if="userExists === false"
                          href="javascript:void(0)"
                          @click="openPasswordSetup()"
                          class="toggle-input-link"
                        >
                          Set password to sign up
                        </a>
                        <a
                          v-else-if="userExists === true"
                          href="javascript:void(0)"
                          @click="usePasswordOrSetup()"
                          class="toggle-input-link"
                        >
                          Use password
                        </a>

                        <!-- Right: Resend Timer / Resend OTP -->
                        <span v-if="timerOut" class="otp-timer-text">
                          {{
                            otpExceeded
                              ? "OTP already sent. Resend in"
                              : "Resend in"
                          }}
                          <span class="time-bold">{{ formattedTime }}</span>
                        </span>
                        <a
                          v-else
                          href="javascript:void(0)"
                          @click="
                            isResetPasswordMode || isNewUserPasswordSetup
                              ? forgotPassword('resend')
                              : register('resend')
                          "
                          class="toggle-input-link"
                        >
                          Resend OTP
                        </a>
                      </div>

                      <!-- Case 2: When showing Password -->
                      <div
                        v-if="!useOtp"
                        class="d-flex justify-content-between align-items-center otp-links-container"
                      >
                        <!-- Left: Login with OTP (underlined) -->
                        <a
                          href="javascript:void(0)"
                          @click="useOtpLogin()"
                          class="toggle-input-link text-decoration-underline"
                        >
                          Login with OTP
                        </a>

                        <!-- Right: Forgot Password? -->
                        <a
                          href="javascript:void(0)"
                          @click="
                            userType === 'candidate'
                              ? openPasswordSetup(true)
                              : (mode = 'forgot')
                          "
                          class="forgot-password-link"
                        >
                          Forgot Password?
                        </a>
                      </div>
                    </div>

                    <!-- Email Input -->
                    <div v-else>
                      <div class="position-relative">
                        <b-form-input
                          v-model="$v.email.$model"
                          @keydown.space.prevent
                          ref="candmail"
                          @keypress.enter="handleSubmit()"
                          type="email"
                          placeholder="Enter Email ID"
                          class="login-input single-field-update"
                          :class="{
                            error:
                              $v.email.$error || (sendOtpError && !otpExceeded),
                          }"
                          :disabled="otpSent"
                        ></b-form-input>
                        <a
                          v-if="otpSent"
                          href="javascript:void(0)"
                          @click="handleIdentifierEdit()"
                          class="desktop-email-edit-btn"
                          >Edit</a
                        >
                      </div>
                      <div
                        class="invalid-msg-txt mt-1"
                        v-if="$v.email.$error && !otpSent"
                      >
                        {{
                          $v.email.$dirty && !$v.email.required
                            ? "Required"
                            : $v.email.required &&
                              (!$v.email.email || !$v.email.alphaEmail)
                            ? "Invalid Email"
                            : !$v.email.maxLength
                            ? "Should not execed 64 characters"
                            : ""
                        }}
                      </div>
                      <div
                        class="invalid-msg-txt mt-1"
                        v-if="sendOtpError && useEmail && !otpExceeded"
                      >
                        {{ sendOtpError }}
                      </div>

                      <!-- Password Field for Email (placed after email input field) -->
                      <div v-if="!useOtp" class="mt-3 position-relative">
                        <b-form-input
                          v-model="$v.password.$model"
                          :type="showPassword ? 'text' : 'password'"
                          placeholder="Password"
                          class="single-field-update"
                          ref="candpass"
                          @keypress.enter="handleSubmit()"
                          autocomplete="off"
                          :class="{ error: $v.password.$error }"
                        ></b-form-input>
                        <span
                          class="password-toggle-icon"
                          @click="showPassword = !showPassword"
                          style="right: 24px"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            v-if="!showPassword"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="3"
                              stroke="#999"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                              stroke="#999"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            v-else
                          >
                            <path
                              d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
                              stroke="#999"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      <div
                        class="invalid-msg-txt mt-1"
                        v-if="!useOtp && $v.password.$error"
                      >
                        {{
                          $v.password.$dirty && !$v.password.required
                            ? "Required"
                            : !$v.password.maxLength && $v.password.required
                            ? "Should not execed 55 characters"
                            : ""
                        }}
                      </div>
                      <div
                        class="invalid-msg-txt mt-1"
                        v-else-if="!useOtp && invalidCredential"
                      >
                        {{ invalidText }}
                      </div>

                      <!-- OTP Field (placed after email input field) -->
                      <div v-if="useOtp && otpSent" class="mt-3">
                        <b-form-input
                          ref="candotp"
                          v-model.trim="otpCode"
                          type="text"
                          placeholder="Enter OTP"
                          class="single-field-update"
                          maxlength="6"
                          @keypress.enter="handleSubmit()"
                          @keypress="otpNumbersOnly"
                          :class="{
                            error: $v.otpCode.$error || invalidCredential,
                          }"
                        ></b-form-input>
                        <div
                          class="invalid-msg-txt mt-1"
                          v-if="$v.otpCode.$error"
                        >
                          {{
                            !$v.otpCode.required
                              ? "Required"
                              : "Please enter a valid OTP"
                          }}
                        </div>
                        <div
                          class="invalid-msg-txt mt-1"
                          v-else-if="invalidCredential"
                        >
                          {{ invalidText }}
                        </div>
                      </div>

                      <!-- Links under the input for Email -->
                      <!-- Case 1: When showing OTP -->
                      <div
                        v-if="useOtp && otpSent"
                        :class="
                          userExists !== null
                            ? 'justify-content-between'
                            : 'justify-content-end'
                        "
                        class="d-flex align-items-center otp-links-container"
                      >
                        <!-- Left: Set password / Use password links -->
                        <a
                          v-if="userExists === false"
                          href="javascript:void(0)"
                          @click="openPasswordSetup()"
                          class="toggle-input-link"
                        >
                          Set password to sign up
                        </a>
                        <a
                          v-else-if="userExists === true"
                          href="javascript:void(0)"
                          @click="usePasswordOrSetup()"
                          class="toggle-input-link"
                        >
                          Use password
                        </a>

                        <!-- Right: Resend Timer / Resend OTP -->
                        <span v-if="timerOut" class="otp-timer-text">
                          {{
                            otpExceeded
                              ? "OTP already sent. Resend in"
                              : "Resend in"
                          }}
                          <span class="time-bold">{{ formattedTime }}</span>
                        </span>
                        <a
                          v-else
                          href="javascript:void(0)"
                          @click="
                            isResetPasswordMode
                              ? forgotPassword('resend')
                              : register('resend')
                          "
                          class="toggle-input-link"
                        >
                          Resend OTP
                        </a>
                      </div>

                      <!-- Case 2: When showing Password -->
                      <div
                        v-if="!useOtp"
                        class="d-flex justify-content-between align-items-center otp-links-container"
                      >
                        <!-- Left: Login with OTP (underlined) -->
                        <a
                          href="javascript:void(0)"
                          @click="useOtpLogin()"
                          class="toggle-input-link text-decoration-underline"
                        >
                          Login with OTP
                        </a>

                        <!-- Right: Forgot Password? -->
                        <a
                          href="javascript:void(0)"
                          @click="
                            userType === 'candidate'
                              ? openPasswordSetup(true)
                              : (mode = 'forgot')
                          "
                          class="forgot-password-link"
                        >
                          Forgot Password?
                        </a>
                      </div>

                      <div
                        v-if="userType === 'candidate' && !otpSent"
                        class="text-right mt-2"
                      >
                        <a
                          href="javascript:void(0)"
                          @click="toggleLoginMode(false)"
                          class="toggle-input-link"
                        >
                          Use Phone Number instead
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="!setPasswordMode">
                    <b-button
                      variant="primary"
                      @click="handleSubmit()"
                      block
                      class="login-submit-btn"
                      :disabled="
                        userType === 'candidate' &&
                        useOtp &&
                        !otpSent &&
                        (useEmail
                          ? !email || email.trim() === ''
                          : !loginPhone.number ||
                            loginPhone.number.trim() === '')
                      "
                    >
                      {{
                        userType === "candidate" && useOtp
                          ? !otpSent
                            ? "Continue with OTP"
                            : userExists === false
                            ? "Sign up"
                            : "Login"
                          : "Login"
                      }}
                    </b-button>

                    <!-- Google SSO (Candidate only) -->
                    <!--
                  <template v-if="userType === 'candidate'">
                    <div class="text-center">
                      <p class="signup-text font-inter">
                        Don't have an account yet?
                        <a
                          href="javascript:void(0)"
                          @click="mode = 'register'"
                          class="register-link"
                          >Register here</a
                        >
                      </p>
                    </div>
                  </template>
            -->

                    <template v-if="userType === 'candidate'">
                      <div class="text-center mt-4">
                        <p class="terms-privacy-text">
                          By Continuing, you accept to the
                          <a
                            href="javascript:void(0)"
                            @click="terms()"
                            class="terms-link"
                            >Terms and Conditions</a
                          >
                          and
                          <a
                            href="javascript:void(0)"
                            @click="goToPrivacyPolicy()"
                            class="terms-link"
                            >Privacy Policy</a
                          >
                          of Hire3x.com
                        </p>
                      </div>
                    </template>
                    <div v-else class="text-center">
                      <p class="signup-text font-inter">
                        Don't have an account yet?
                        <a @click="goToDemo()" class="register-link pointer"
                          >Request Demo</a
                        >
                      </p>
                    </div>
                  </div>
                </template>

                <!-- Business login web -->
                <template v-else>
                  <div class="mb-3 mt-4">
                    <b-form-input
                      v-model="$v.email.$model"
                      @keydown.space.prevent
                      ref="candmail"
                      @keypress.enter="handleSubmit()"
                      type="email"
                      placeholder="Email"
                      class="login-input single-field-update"
                      :class="{ error: $v.email.$error }"
                    ></b-form-input>
                    <div class="invalid-msg-txt mt-1" v-if="$v.email.$error">
                      {{
                        $v.email.$dirty && !$v.email.required
                          ? "Required"
                          : $v.email.required &&
                            (!$v.email.email || !$v.email.alphaEmail)
                          ? "Invalid Email"
                          : !$v.email.maxLength
                          ? "Should not execed 64 characters"
                          : ""
                      }}
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="position-relative">
                      <b-form-input
                        v-model="$v.password.$model"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Password"
                        class="login-input single-field-update"
                        ref="candpass"
                        @keypress.enter="handleSubmit()"
                        autocomplete="off"
                        :class="{ error: $v.password.$error }"
                      ></b-form-input>
                      <span
                        class="password-toggle-icon"
                        @click="showPassword = !showPassword"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          v-if="!showPassword"
                        >
                          <path
                            d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                            stroke="#999"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <circle
                            cx="12"
                            cy="12"
                            r="3"
                            stroke="#999"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          v-else
                        >
                          <path
                            d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
                            stroke="#999"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div class="invalid-msg-txt mt-1" v-if="$v.password.$error">
                      {{
                        $v.password.$dirty && !$v.password.required
                          ? "Required"
                          : !$v.password.maxLength && $v.password.required
                          ? "Should not execed 55 characters"
                          : ""
                      }}
                    </div>

                    <div
                      class="invalid-msg-txt mt-1"
                      v-else-if="invalidCredential"
                    >
                      {{ invalidText }}
                    </div>
                  </div>
                  <div class="text-left mb-4">
                    <a
                      href="javascript:void(0)"
                      class="forgot-link"
                      @click="mode = 'forgot'"
                      >Forgot your password?</a
                    >
                  </div>

                  <b-button
                    variant="primary"
                    @click="handleSubmit()"
                    block
                    class="login-submit-btn mb-3"
                  >
                    Login
                  </b-button>
                  <div class="text-center">
                    <p class="signup-text font-inter">
                      Don't have an account yet?
                      <a @click="goToDemo()" class="register-link pointer"
                        >Request Demo</a
                      >
                    </p>
                  </div>
                </template>
              </div>
            </b-overlay>
          </div>

          <!-- Forgot Password View Web -->
          <div
            v-if="mode === 'forgot'"
            class="login-form-wrapper-2 forgot d-flex flex-column"
          >
            <b-overlay
              :show="show"
              :opacity="overlayOpacity"
              rounded="sm"
              class="h-100"
            >
              <template #overlay>
                <div class="overlaybox">
                  <b-spinner class="login-loader"></b-spinner>
                  <span class="overlaytxt">Loading</span>
                </div>
              </template>
              <hr
                id="hideinmobile"
                style="border-top: 1px solid #dee2e6"
                class="mb-4 mt-4"
              />
              <h3 class="font-inter fw-600 color-darkblack mb-2 fs-22">
                Forgot Passwords?
              </h3>
              <p class="font-inter color-gray mb-4 fs-14">
                Enter the email address associated with this account.
              </p>

              <div class="mb-4">
                <b-form-input
                  type="email"
                  placeholder="Email"
                  class="login-input single-field-update"
                  v-model="$v.email.$model"
                  @keydown.space.prevent
                  ref="candmail"
                  @keypress.enter="forgotPassword()"
                  :class="{ error: $v.email.$error || invalidCredential }"
                ></b-form-input>
                <div
                  class="invalid-msg-txt"
                  v-if="$v.email.$error || invalidCredential"
                >
                  {{
                    $v.email.$dirty && !$v.email.required
                      ? "Required"
                      : $v.email.required &&
                        (!$v.email.email || !$v.email.alphaEmail)
                      ? "Invalid Email"
                      : !$v.email.maxLength
                      ? "Should not execed 64 characters"
                      : invalidCredential
                      ? invalidText
                      : ""
                  }}
                </div>
              </div>

              <b-button
                @click="forgotPassword()"
                variant="primary"
                block
                class="login-submit-btn mb-4"
              >
                Send OTP
              </b-button>

              <div class="text-center mt-2">
                <a
                  href="javascript:void(0)"
                  @click="mode = 'login'"
                  class="back-to-login font-inter fw-500 color-blue text-decoration-none"
                >
                  <i class="fas fa-arrow-left mr-1"></i> Back to login
                </a>
              </div>
            </b-overlay>
          </div>

          <!-- Verify OTP View Web -->
          <div
            v-if="
              (mode === 'otp' || mode === 'forgotOtp') &&
              userType !== 'candidate'
            "
            class="login-form-wrapper-2 forgotOtp d-flex flex-column"
          >
            <b-overlay
              :show="show"
              :opacity="overlayOpacity"
              rounded="sm"
              class="h-100"
            >
              <template #overlay>
                <div class="overlaybox">
                  <b-spinner class="login-loader"></b-spinner>
                  <span class="overlaytxt">Loading</span>
                </div>
              </template>
              <hr
                id="hideinmobile"
                style="border-top: 1px solid #dee2e6"
                class="mb-4 mt-4"
              />
              <h3 class="font-inter fw-600 color-darkblack mb-2 fs-22">
                Verify OTP
              </h3>
              <p class="font-inter color-gray mb-4 fs-14">
                Please enter the 6 digits OTP sent to :-
                <a
                  href="javascript:void(0)"
                  class="color-blue text-decoration-none"
                >
                  {{ formatEmail }}</a
                >
              </p>

              <div
                class="d-flex otp-input-row justify-content-between"
                :class="
                  invalidCredential ||
                  ($v.otpDigits.$dirty && $v.otpDigits.$invalid && verifyotp)
                    ? 'mb-1'
                    : 'mb-4'
                "
              >
                <input
                  ref="firstInput"
                  type="number"
                  :class="{
                    error:
                      invalidCredential ||
                      ($v.otpDigits.num1.$error && verifyotp),
                  }"
                  maxlength="1"
                  placeholder="0"
                  @keydown="moveToNextField($event, 'secondInput', null)"
                  @keypress="restrictToOneDigit"
                  class="otp-box no-number"
                  v-model="$v.otpDigits.num1.$model"
                />
                <input
                  ref="secondInput"
                  type="number"
                  :class="{
                    error:
                      invalidCredential ||
                      ($v.otpDigits.num2.$error && verifyotp),
                  }"
                  @keydown="moveToNextField($event, 'thirdInput', 'firstInput')"
                  @keypress="restrictToOneDigit"
                  @paste="preventPaste"
                  placeholder="0"
                  maxlength="1"
                  class="otp-box no-number"
                  v-model="$v.otpDigits.num2.$model"
                />
                <input
                  ref="thirdInput"
                  type="number"
                  :class="{
                    error:
                      invalidCredential ||
                      ($v.otpDigits.num3.$error && verifyotp),
                  }"
                  @keydown="
                    moveToNextField($event, 'fourthInput', 'secondInput')
                  "
                  @keypress="restrictToOneDigit"
                  @paste="preventPaste"
                  placeholder="0"
                  maxlength="1"
                  class="otp-box no-number"
                  v-model="$v.otpDigits.num3.$model"
                />
                <input
                  ref="fourthInput"
                  type="number"
                  :class="{
                    error:
                      invalidCredential ||
                      ($v.otpDigits.num4.$error && verifyotp),
                  }"
                  @keydown="moveToNextField($event, 'fifthInput', 'thirdInput')"
                  @keypress="restrictToOneDigit"
                  @paste="preventPaste"
                  placeholder="0"
                  maxlength="1"
                  class="otp-box no-number"
                  v-model="$v.otpDigits.num4.$model"
                />
                <input
                  ref="fifthInput"
                  type="number"
                  :class="{
                    error:
                      invalidCredential ||
                      ($v.otpDigits.num5.$error && verifyotp),
                  }"
                  @keydown="
                    moveToNextField($event, 'sixthInput', 'fourthInput')
                  "
                  @keypress="restrictToOneDigit"
                  @paste="preventPaste"
                  placeholder="0"
                  maxlength="1"
                  class="otp-box no-number"
                  v-model="$v.otpDigits.num5.$model"
                />
                <input
                  ref="sixthInput"
                  type="number"
                  :class="{
                    error:
                      invalidCredential ||
                      ($v.otpDigits.num6.$error && verifyotp),
                  }"
                  @keypress="restrictToOneDigit"
                  @keypress.enter="
                    mode === 'otp' ? handleSubmit() : resetPasswordOTP()
                  "
                  @keydown="moveToNextField($event, null, 'fifthInput')"
                  @paste="preventPaste"
                  placeholder="0"
                  maxlength="1"
                  class="otp-box no-number"
                  v-model="$v.otpDigits.num6.$model"
                />
              </div>
              <div class="invalid-msg-txt" v-if="invalidCredential">
                {{ invalidText }}
              </div>
              <div
                class="invalid-msg-txt"
                v-else-if="
                  $v.otpDigits.$dirty && $v.otpDigits.$invalid && verifyotp
                "
              >
                Enter a valid otp
              </div>
              <template v-if="!otpExceeded">
                <div class="text-left mb-4">
                  <span class="font-inter fs-13 color-gray"
                    >Didn't receive code?
                  </span>
                  <span v-if="timerOut" class="font-inter fs-13 color-gray">
                    Resend in
                    <span
                      v-if="timerOut"
                      class="fw-500 fs-13 text-decoration-none"
                      style="color: red"
                      >{{ formattedTime }}</span
                    >
                  </span>
                  <a
                    v-else
                    href="javascript:void(0)"
                    @click="forgotPassword('resendotp')"
                    class="color-blue fw-500 text-decoration-none"
                    >Resend OTP</a
                  >
                </div>
              </template>
              <div v-else class="text-left mb-4">
                <span class="fam-inter fs-13 color-gray"
                  >OTP has already been sent.<br v-if="isMobile" />
                  You can request a new OTP in
                </span>
                <span
                  class="fw-500 fs-13 text-decoration-none"
                  style="color: red"
                  >{{ formattedTime }}</span
                >
              </div>
              <b-button
                @click="mode === 'otp' ? handleSubmit() : resetPasswordOTP()"
                variant="primary"
                block
                class="login-submit-btn mb-4"
              >
                Verify
              </b-button>

              <div class="text-center mt-2">
                <a
                  href="javascript:void(0)"
                  @click="mode = 'login'"
                  class="back-to-login font-inter fw-500 color-blue text-decoration-none"
                >
                  <i class="fas fa-arrow-left mr-1"></i> Back to login
                </a>
              </div>
            </b-overlay>
          </div>

          <!-- Reset Password View Web -->
          <div
            v-if="mode === 'reset'"
            class="login-form-wrapper-2 reset d-flex flex-column"
          >
            <b-overlay
              :show="show"
              :opacity="overlayOpacity"
              rounded="sm"
              class="h-100"
            >
              <template #overlay>
                <div class="overlaybox">
                  <b-spinner class="login-loader"></b-spinner>
                  <span class="overlaytxt">Loading</span>
                </div>
              </template>
              <hr
                id="hideinmobile"
                style="border-top: 1px solid #dee2e6"
                class="mb-4 mt-4"
              />
              <h3 class="font-inter fw-600 color-darkblack mb-2 fs-22">
                Reset Password
              </h3>
              <p class="font-inter color-gray mb-4 fs-14">
                Please enter the new password to reset your password.
              </p>
              <div class="mb-3">
                <div class="position-relative">
                  <b-form-input
                    :type="showPass ? 'text' : 'password'"
                    @input="validatePassword('rePassword')"
                    v-model="$v.rePassword.$model"
                    ref="passnew"
                    placeholder="New Password"
                    class="login-input single-field-update pr-5"
                    @keypress.enter="resetPasswordAdmin()"
                    :class="{
                      error: $v.rePassword.$error || checkpassowrdInvalid,
                    }"
                  ></b-form-input>
                  <span
                    class="password-toggle-icon"
                    @click="showPass = !showPass"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      v-if="!showPass"
                    >
                      <path
                        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                        stroke="#999"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="#999"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      v-else
                    >
                      <path
                        d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
                        stroke="#999"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                <div
                  class="invalid-msg-txt"
                  v-if="$v.rePassword.$error || checkpassowrdInvalid"
                >
                  {{
                    $v.rePassword.$dirty && !$v.rePassword.required
                      ? "Required"
                      : checkpassowrdInvalid
                      ? passwordValidation
                      : !$v.rePassword.maxLength && $v.rePassword.required
                      ? "Should not exceed 55 characters"
                      : ""
                  }}
                </div>
              </div>
              <div class="mb-4 position-relative">
                <b-form-input
                  type="password"
                  @paste="preventPaste"
                  ref="pass"
                  v-model="$v.reConfirmpassword.$model"
                  @keypress.enter="resetPasswordAdmin()"
                  :class="{
                    error: $v.reConfirmpassword.$error || match,
                  }"
                  placeholder="Confirm Password"
                  class="login-input pr-5 single-field-update"
                ></b-form-input>
                <div
                  class="invalid-msg-txt"
                  v-if="$v.reConfirmpassword.$error || match"
                >
                  {{
                    $v.reConfirmpassword.$dirty &&
                    !$v.reConfirmpassword.required
                      ? "Required"
                      : !$v.reConfirmpassword.maxLength &&
                        $v.reConfirmpassword.required
                      ? "Should not exceed 55 characters"
                      : match
                      ? "Password mismatch"
                      : ""
                  }}
                </div>
              </div>

              <!-- OTP field — visible only after passwords are validated and OTP sent -->
              <div v-if="showSetPasswordOtp" class="mb-2">
                <b-form-input
                  v-model.trim="otpCode"
                  type="text"
                  placeholder="Enter OTP"
                  class="login-input single-field-update"
                  maxlength="6"
                  @keypress="otpNumbersOnly"
                  @keypress.enter="resetPasswordAdmin()"
                  :class="{ error: $v.otpCode.$error || invalidCredential }"
                ></b-form-input>
                <div class="invalid-msg-txt mt-1" v-if="$v.otpCode.$error">
                  {{
                    !$v.otpCode.required
                      ? "Required"
                      : "Please enter a valid OTP"
                  }}
                </div>
                <div class="invalid-msg-txt mt-1" v-else-if="invalidCredential">
                  {{ invalidText }}
                </div>
              </div>
              <!-- Resend OTP row -->
              <div
                v-if="showSetPasswordOtp"
                class="d-flex justify-content-end mb-3"
              >
                <span
                  v-if="timerOut"
                  style="font-size: 13px; color: #4a7eff; font-weight: 500"
                >
                  {{
                    otpExceeded ? "OTP already sent. Resend in" : "Resend in"
                  }}
                  <span style="font-weight: 600">{{ formattedTime }}</span>
                </span>
                <a
                  v-else
                  href="javascript:void(0)"
                  @click="
                    isResetPasswordMode || isNewUserPasswordSetup
                      ? forgotPassword('resend')
                      : register('resend')
                  "
                  style="font-size: 13px; color: #4a7eff; font-weight: 500"
                  >Resend OTP</a
                >
              </div>

              <b-button
                @click="resetPasswordAdmin()"
                variant="primary"
                block
                class="login-submit-btn mb-4"
              >
                Reset Password
              </b-button>

              <div class="text-center mt-2">
                <a
                  href="javascript:void(0)"
                  @click="mode = 'login'"
                  class="back-to-login font-inter fw-500 color-blue text-decoration-none"
                >
                  <i class="fas fa-arrow-left mr-1"></i> Back to login
                </a>
              </div>
            </b-overlay>
          </div>
          <Popupcomponent
            v-if="showPopup || registered"
            :showPopup="showPopup"
            :registered="registered"
            :candExists="candExists"
            :invalidText="invalidText"
            :successText="successText"
          />
        </div>
      </div>
    </div>
  </login-modal-shell>
</template>

<script>
import loginMixin from "@/utils/mixins/loginMixin";
import googleSSOMixin from "@/utils/mixins/googleSSO";
import Popupcomponent from "./Popup.vue";
import LoginModalShell from "./LoginModalShell.vue";
import PhoneNumber from "./PhoneNumber.vue";

export default {
  components: { Popupcomponent, LoginModalShell, PhoneNumber },
  mixins: [loginMixin, googleSSOMixin],
  props: {
    uuid: {
      default: null,
    },
    jobId: {
      default: null,
    },
    newclass: {
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    hasSetPasswordErrors() {
      return (
        (this.$v.setPassword && this.$v.setPassword.$error) ||
        this.checkpassowrdInvalid ||
        (this.$v.confirmPassword && this.$v.confirmPassword.$error) ||
        this.match ||
        (this.$v.otpCode && this.$v.otpCode.$error) ||
        this.invalidCredential
      );
    },
  },
  watch: {
    otpCode(newVal) {
      const digits = newVal.toString().replace(/\D/g, "").slice(0, 6).split("");
      this.otpDigits.num1 = digits[0] || "";
      this.otpDigits.num2 = digits[1] || "";
      this.otpDigits.num3 = digits[2] || "";
      this.otpDigits.num4 = digits[3] || "";
      this.otpDigits.num5 = digits[4] || "";
      this.otpDigits.num6 = digits[5] || "";
      if (newVal) {
        this.$v.otpDigits.$touch();
      } else {
        this.$v.otpDigits.$reset();
      }
    },
  },
  methods: {
    async handleSubmit() {
      // Touch fields FIRST so $error is reactive before any blur() or async calls
      if (this.setPasswordMode) {
        this.$v.setPassword.$touch();
        this.$v.confirmPassword.$touch();
        if (this.showSetPasswordOtp) this.$v.otpCode.$touch();
      }

      if (this.$refs.candmail && typeof this.$refs.candmail.blur === "function")
        this.$refs.candmail.blur();
      if (this.$refs.candpass && typeof this.$refs.candpass.blur === "function")
        this.$refs.candpass.blur();
      if (
        this.$refs.candphone &&
        typeof this.$refs.candphone.blur === "function"
      )
        this.$refs.candphone.blur();
      if (this.$refs.candotp && typeof this.$refs.candotp.blur === "function")
        this.$refs.candotp.blur();
      if (
        this.$refs.setPassField &&
        typeof this.$refs.setPassField.blur === "function"
      )
        this.$refs.setPassField.blur();
      if (
        this.$refs.confirmPassField &&
        typeof this.$refs.confirmPassField.blur === "function"
      )
        this.$refs.confirmPassField.blur();

      let flag = this.userType;

      if (this.setPasswordMode) {
        if (
          this.$v.setPassword.$invalid ||
          this.$v.confirmPassword.$invalid ||
          this.match
        ) {
          return;
        }

        if (!this.showSetPasswordOtp) {
          // Set Password (new user) path only — reset-password always arrives here
          // with showSetPasswordOtp already true (set by candidateForgotPassword).
          // Store user data and reveal the OTP field using the already-sent login OTP.
          let userdata = {
            email: this.email ? this.email.trim() : "",
            password: this.setPassword ? this.setPassword.trim() : "",
            confirmPassword: this.confirmPassword
              ? this.confirmPassword.trim()
              : "",
            countryCode: this.loginPhoneCountryCode
              ? this.loginPhoneCountryCode.trim()
              : "+91",
            phoneNumber: this.loginPhone.number
              ? this.loginPhone.number.replace(/\s+/g, "")
              : "",
          };
          this.$store.commit("userVUEX/setUserData", userdata);
          // Start/resume the countdown from retryAfter if it isn't already running
          if (!this.timerOut && this.retryAfter > 0) {
            this.timerOut = true;
            this.startTimer();
          }
          this.showSetPasswordOtp = true;
        } else {
          this.$v.otpCode.$touch();
          if (this.$v.otpCode.$invalid) {
            return;
          }
          if (this.isResetPasswordMode) {
            await this.resetPasswordOTP();
          } else {
            await this.registerCandidate();
          }
        }
        return;
      }

      if (flag === "candidate") {
        if (this.useOtp) {
          if (!this.otpSent) {
            await this.register();
          } else {
            this.$v.otpCode.$touch();
            if (this.$v.otpCode.$invalid) {
              return;
            }

            if (this.userExists === false) {
              await this.registerCandidate();
            } else {
              await this.login();
            }
          }
        } else {
          await this.login();
        }
      } else {
        await this.login();
      }
    },
    handleHide() {
      this.$emit("close-modal");
      if (typeof this.clearAndReset === "function") {
        this.clearAndReset(true);
      }
      if (typeof this.clearResumeClinic === "function") {
        this.clearResumeClinic();
      }

      try {
        if (
          this.$route &&
          this.$route.query &&
          this.$route.query.roadmapSkills
        ) {
          const newQuery = { ...this.$route.query };
          delete newQuery.roadmapSkills;
          this.$router.replace({ query: newQuery }).catch(() => {});
        }
      } catch (e) {
        // ignore router errors
      }
    },
  },
};
</script>

<style>
.login-modal-body {
  border-radius: 40px !important;
  overflow: visible !important;
}

#loginModal .modal-content {
  border-radius: 40px !important;
  overflow: visible !important;
}

#loginModal .modal-dialog {
  max-width: 860px !important;
}

#loginModal .no-gutters {
  background-color: #ffffff;
  border-radius: 40px;
  overflow: hidden;
  height: 100%;
}

.right-panel {
  background-color: #ffffff;
  border-radius: 40px;
  z-index: 2;
  position: relative;
  left: -34px;
}

.login-modal-container {
  position: relative;
  background: #fff;
  height: 530px;
  border-radius: 40px;
}

.modal-bg-transparent {
  background: transparent !important;
}

.login-form-wrapper {
  padding: 20px 0px 20px 20px;
  margin-right: -10px;
}

.login-form-wrapper-2 {
  padding: 23px 0px 25px 25px;
}

.close-modal-btn {
  position: absolute;
  top: -1px;
  right: -43px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  z-index: 1000;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.close-modal-btn:hover {
  transform: scale(1.1);
}

.left-panel {
  background-color: #041525;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.left-panel::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    circle at 50% 50%,
    rgba(255, 255, 255, 0.05) 0%,
    transparent 70%
  );
  z-index: 2;
}

.carousel-title {
  font-size: 28px;
  line-height: 1.25;
  color: #ffffff;
  font-weight: 700;
  z-index: 10;
  position: relative;
  margin-top: 20px;
}

.illustration-placeholder {
  z-index: 5;
}

.slider-dots-container {
  z-index: 10;
  padding-bottom: 25px;
  position: absolute;
  width: 100%;
  bottom: -18px;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  margin: 0 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background-color: #fff;
  width: 7px;
  height: 7px;
}

/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.character-img {
  width: 100%;
  display: block;
  z-index: 2;
  position: relative;
}

.active-tab-label {
  height: 34px;
  margin-bottom: 16px;
  display: inline-block;
  position: relative;
  width: 100%;
  text-align: justify;
}

.active-tab-label-2 {
  margin-bottom: 22px;
  display: inline-block;
  position: relative;
  width: 100%;
  text-align: justify;
}

.active-tab-label::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 18px;
  width: 58px;
  height: 2px;
  background-color: #4a7eff;
}

.active-tab-label-2::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 18px;
  width: 68px;
  height: 2px;
  background-color: #4a7eff;
}

.color-blue {
  color: #4a7eff;
  font-size: 14px;
}

.back-to-login:hover,
.back-to-login:focus {
  color: #3b6eef !important;
  text-decoration: none;
}

.toggle-container {
  background: #e2e8f0;
  border-radius: 32px;
  box-shadow: 0px 1px 2px 0px #0000000f;
  height: 48px !important;
  padding: 4px !important;
  display: flex !important;
  align-items: center !important;
}

.toggle-btn {
  border-radius: 25px;
  border: none;
  background: transparent;
  padding: 13px 20px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toggle-btn.active {
  color: #ffffff;
  background: linear-gradient(
    90deg,
    #20639b 0%,
    #2f4691 31.02%,
    #4e2f91 69.64%,
    #7c1585 131.69%
  );
}

.login-input {
  background-color: #fff !important;
  border: 1px solid #efefefee;
  border-radius: 25px !important;
  padding: 12px 20px !important;
  height: 42px !important;
  font-size: 15px;
  transition: all 0.2s ease;
}

.login-input:focus,
.phone-input:focus,
.single-field-update:focus,
.password-single-field:focus,
.input-field-container .form-control:focus,
.phone-inputField .form-control:focus {
  border-color: #4a7eff !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Error state takes priority over focus — border stays red until value changes */
.login-input.error:focus,
.single-field-update.error:focus,
.input-field-container .form-control.error:focus,
.phone-inputField .form-control.error:focus {
  border-color: #dc143c !important;
  box-shadow: none !important;
}

.login-input.error,
.single-field-update.error,
.password-single-field.error,
.input-field-container .form-control.error,
.phone-inputField .form-control.error {
  border-color: #dc143c !important;
}

.password-input {
  padding-right: 40px !important;
}

.forgot-link {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #333;
  font-weight: 500;
  border-bottom: 1px solid #d7d7d7;
  color: #000000;
}

.forgot-link:hover {
  color: #333;
  text-decoration: none;
}

.login-submit-btn {
  background-color: #4a7eff !important;
  border: none !important;
  border-radius: 25px !important;
  height: 48px;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.2s ease;
}

.register .login-submit-btn {
  height: 52px;
}

.login-submit-btn:not(:disabled):hover {
  background-color: #4a7eff !important;
  transform: translateY(-1px);
  box-shadow: none;
}

.login-submit-btn:focus,
.login-submit-btn:active,
.login-submit-btn:active:focus {
  box-shadow: none !important;
  outline: none !important;
}

.separator {
  position: relative;
  text-align: center;
}

.separator::before {
  content: "";
  position: absolute;
  top: 54%;
  left: 0;
  width: 100%;
  height: 1px;
  background: #cbd5e1;
}

.separator span {
  background: #fff;
  padding: 0 8px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  position: relative;
  color: #757575;
  font-size: 13px;
}

.google-login-btn {
  border: 1px solid #cbd5e1 !important;
  border-radius: 25px !important;
  height: 48px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff !important;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  color: #64748b !important;
  margin-top: 24px !important;
}

.google-login-btn:hover {
  background: #fcfcfc !important;
  border-color: #cbd5e1 !important;
}

.signup-text {
  font-weight: 500;
  font-size: 12px;
  color: #000000;
}

.register-link {
  color: #4a7eff;
  font-weight: 600;
  text-decoration: underline;
}

.register-link:hover,
.register-link:focus {
  color: #3b6eef;
  text-decoration: underline;
}

/* Registration specific styles */
.phone-input-group {
  overflow: hidden;
}

.country-code {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.flag-icon-small {
  width: 20px;
  border-radius: 2px;
}

.divider-v {
  width: 1px;
  height: 20px;
  background-color: #efefef;
}

.no-shadow {
  box-shadow: none !important;
}

.password-toggle-icon {
  position: absolute;
  right: 15px;
  top: 23px;
  transform: translateY(-50%);
  cursor: pointer;
}

.terms-label {
  font-size: 11px;
  color: #666;
  line-height: 1.4;
}

.terms-label a {
  color: #4a7eff;
  text-decoration: underline;
}

.terms-label a:hover,
.terms-label a:focus {
  color: #3b6eef;
  text-decoration: underline;
}

.custom-checkbox-circle {
  transform: scale(0.9);
}

.custom-checkbox-circle .custom-control-label::before,
.custom-checkbox-circle
  .custom-control-input:focus
  ~ .custom-control-label::before,
.custom-checkbox-circle
  .custom-control-input:active
  ~ .custom-control-label::before,
.custom-checkbox-circle
  .custom-control-input:focus:not(:checked)
  ~ .custom-control-label::before {
  box-shadow: none !important;
  outline: none !important;
}

.copyright-footer {
  font-family: "Inter", sans-serif;
  font-size: 10px;
  color: #999;
}

.fs-10 {
  font-size: 10px;
}

/* Error alert */
.error-alert {
  background: #fff0f0;
  border: 1px solid #ffcccc;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 13px;
  color: #cc0000;
  font-family: "Inter", sans-serif;
}

/* OTP inputs */
.otp-input-row {
  gap: 10px;
}

.otp-box {
  flex: 1;
  width: 44px;
  height: 50px;
  border: 1.5px solid #efefef;
  border-radius: 25px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  outline: none;
  transition: border-color 0.2s ease;
}

.otp-box:focus {
  box-shadow: none;
  outline: none;
}

.otp-box:not(:placeholder-shown) {
  border-color: #4a7eff;
}

.single-field-update {
  background-color: #ffffff !important;
  border-radius: 32px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0px 1px 2px 0px #0000000d !important;
  height: 48px !important;
  color: #64748b !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  padding: 12px 24px !important;
}

.single-field-update::placeholder {
  color: #64748b !important;
  opacity: 1 !important;
}

.single-field-update:disabled,
.single-field-update[disabled],
.phone-inputField .form-control:disabled,
.phone-inputField .form-control[disabled] {
  background: #f4f4f4 !important;
  box-shadow: 0px 1px 2px 0px #0000000d !important;
  border: none !important;
  opacity: 1 !important;
  cursor: default !important;
}

#loginModal input:disabled:-webkit-autofill,
#loginModal input:disabled:-webkit-autofill:hover,
#loginModal input:disabled:-webkit-autofill:focus,
#loginModal input[disabled]:-webkit-autofill,
#loginModal input[disabled]:-webkit-autofill:hover,
#loginModal input[disabled]:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #f4f4f4 inset !important;
  box-shadow: 0 0 0 1000px #f4f4f4 inset !important;
  -webkit-text-fill-color: #64748b !important;
}

#loginModal input:-webkit-autofill,
#loginModal input:-webkit-autofill:hover,
#loginModal input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
  box-shadow: 0 0 0 1000px #ffffff inset !important;
  -webkit-text-fill-color: #64748b !important;
}

.otp-links-container {
  margin-top: 16px !important;
}

.otp-timer-text {
  font-family: "Inter", sans-serif !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  color: #4a7eff !important;
}

.otp-timer-text .time-bold {
  font-weight: 600 !important;
}

.password-single-field {
  border-radius: 32px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0px 1px 2px 0px #0000000d !important;
  height: 48px !important;
  color: #64748b !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  margin-top: 16px !important;
  padding: 12px 24px !important;
}

.password-single-field::placeholder {
  color: #64748b !important;
  opacity: 1 !important;
}

.set-password-container {
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  min-height: 420px !important;
  overflow: auto;
}

.otp-sent-info-box {
  background: linear-gradient(
    90deg,
    rgba(74, 126, 255, 0.06) 0%,
    rgba(0, 38, 134, 0.06) 100%
  );
  border-radius: 40px !important;
  padding: 16px 24px !important;
}

.info-box-label {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #667085 !important;
}

.info-box-value {
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #1f1f1f !important;
}

.info-box-edit-link {
  font-family: "Inter", sans-serif !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #4a7eff !important;
  text-decoration: underline !important;
  cursor: pointer;
}

.forgot-password-link {
  color: #333333 !important;
  font-size: 13px !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  cursor: pointer;
}

.terms-privacy-text {
  font-family: "Manrope", sans-serif !important;
  color: #757575 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 16px;
  margin: 0 auto !important;
}

.terms-privacy-text .terms-link {
  color: #4a7eff !important;
  text-decoration: underline !important;
  font-weight: 500 !important;
  cursor: pointer;
}

/* Phone Number Design */
.input-field-container .iti {
  width: 100% !important;
}

.input-field-container .iti__selected-flag {
  border-right: none !important;
  border-bottom-left-radius: 32px !important;
  border-top-left-radius: 32px !important;
  background-color: transparent !important;
  padding-left: 24px !important;
  padding-right: 16px !important;
}

.input-field-container .iti__flag,
.input-field-container .iti__selected-dial-code {
  flex-shrink: 0 !important;
}

.input-field-container .iti__selected-dial-code {
  color: #7a7a7a !important;
  font-weight: 600 !important;
  font-family: "Inter", sans-serif !important;
}

.phone-edit-action {
  position: absolute;
  right: 24px;
  top: 24px;
  transform: translateY(-50%);
  color: #4a7eff !important;
  font-size: 13px !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  cursor: pointer;
  z-index: 3;
}

.phone-inputField .form-control {
  border-radius: 32px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0px 1px 2px 0px #0000000d !important;
  height: 48px !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  color: #64748b !important;
  opacity: 1 !important;
  padding-right: 24px !important;
  padding-left: 105px !important;
}

.phone-inputField .form-control::placeholder {
  color: #64748b !important;
  opacity: 1 !important;
}

.phone-inputField .iti__selected-flag {
  border-right: none !important;
  border-bottom-left-radius: 32px !important;
  border-top-left-radius: 32px !important;
  background-color: transparent !important;
  padding-left: 24px !important;
  padding-right: 16px !important;
}

.phone-inputField label {
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  color: #64748b !important;
  opacity: 1 !important;
  left: 105px !important;
}

.phone-inputField.focused label,
.phone-inputField input:focus + label,
.phone-inputField input:not(:placeholder-shown) + label {
  display: none !important;
}

.phone-inputField .iti__selected-dial-code {
  color: #7a7a7a !important;
  font-weight: 600 !important;
  font-family: "Inter", sans-serif !important;
}

.toggle-input-link {
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  color: #4a7eff !important;
  text-decoration: none !important;
  font-size: 13px !important;
  cursor: pointer;
}

/* phone-input mirrors .login-input but deliberately omits padding-left
   so intlTelInput can inject the correct value for the flag+dialcode button */
.phone-input {
  background-color: #fff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 32px !important;
  box-shadow: 0px 1px 2px 0px #0000000d !important;
  height: 48px !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  color: #64748b !important;
  opacity: 1 !important;
  padding-top: 12px !important;
  padding-right: 24px !important;
  padding-bottom: 12px !important;
  padding-left: 105px !important;
  font-size: 15px;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.phone-input:focus {
  border-color: #4a7eff;
  box-shadow: none;
  outline: none;
}

.phone-input::placeholder {
  font-size: 14px !important;
  font-weight: 500 !important;
  font-family: "Inter", sans-serif !important;
  color: #64748b !important;
}

.phone-input:disabled,
.phone-input[disabled] {
  background-color: #ffffff !important;
  opacity: 1 !important;
  cursor: default !important;
}

.input-field-container .iti--inline-dropdown .iti__dropdown-content {
  width: 18vw !important;
}

.input-field-container
  .iti--inline-dropdown
  .iti__country-list::-webkit-scrollbar {
  width: 3px !important;
  background: #fff;
  border-radius: 20px;
}

.input-field-container
  .iti--inline-dropdown
  .iti__country-list::-webkit-scrollbar-thumb {
  background: #dfdfdf !important;
  border-radius: 20px;
  height: 20px !important;
}

.input-field-container
  .iti--inline-dropdown
  .iti__country-list::-webkit-scrollbar-thumb:hover {
  background: #dfdfdf !important;
}

.input-field-container .iti__search-input {
  color: #000;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18.9px;
  height: 34px;
  padding: 7px 11px;
  border-radius: 8px;
  /* background: #e8eff4; */
}

.input-field-container .iti--inline-dropdown .iti__country-list {
  max-height: 185px;
  padding-right: 2px;
  margin-top: 3px;
  border-top: none !important;
}

.input-field-container .iti--inline-dropdown .iti__dropdown-content {
  position: absolute;
  z-index: 2;
  margin-top: 3px;
  margin-left: -1px;
  border: 1px solid #ccc;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  padding: 5px;
}

.iti--inline-dropdown .iti__dropdown-content {
  border-radius: 11px;
}

.input-field-container .iti--show-selected-dial-code .iti__selected-flag {
  background: transparent !important;
  border-radius: 10px;
}

.no-number::-webkit-outer-spin-button,
.no-number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-number {
  appearance: textfield;
  -moz-appearance: textfield;
}

.register-overflow {
  padding-left: 6px;
  height: 420px;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  overflow-x: hidden;
}

.login-overflow {
  height: 420px;
  max-height: calc(100vh - 160px);
  overflow: hidden !important;
}

.login-overflow::-webkit-scrollbar,
.register-overflow::-webkit-scrollbar {
  scroll-behavior: smooth !important;
  width: 0px !important;
  height: 0px !important;
  background-color: transparent !important;
}

.login-form-wrapper-2.reset,
.login-form-wrapper-2.forgot,
.login-form-wrapper-2.forgotOtp {
  height: 530px;
  max-height: calc(100vh - 60px);
  overflow-y: auto;
}

@media (max-width: 1028px) {
  /*
   * On mobile, b-modal is NOT used — LoginModalShell renders a plain fixed div.
   * All the old b-modal wrapper overrides (#loginModal .modal, .modal-dialog-centered,
   * #loginModal___BV_modal_backdrop_, etc.) are removed.
   * Positioning/height of the overlay itself is controlled in LoginModalShell.vue.
   */

  /* ── Container fills the overlay div ── */
  .login-modal-container {
    border-radius: 0;
    height: 530px;
    min-height: unset;
    overflow: hidden;
  }

  .bussiness-login .login-modal-container {
    height: 530px;
  }

  .login-modal-container .login-overflow,
  .login-modal-container .register-overflow {
    height: 420px !important;
  }

  .login-modal-container .login-form-wrapper-2.reset,
  .login-modal-container .login-form-wrapper-2.forgot,
  .login-modal-container .login-form-wrapper-2.forgotOtp {
    height: 420px !important;
  }

  .close-modal-btn {
    display: none;
  }

  .right-panel {
    background: #fff;
    left: 0;
    border-radius: 0;
  }

  .no-gutters {
    border-radius: 0;
    overflow: visible;
  }

  .login-form-wrapper {
    padding: 18px 0px;
  }

  .login-form-wrapper-2.reset,
  .login-form-wrapper-2.forgot,
  .login-form-wrapper-2.forgotOtp {
    height: calc(100vh - 160px);
  }

  body.has-mobile-banner .login-form-wrapper-2.reset,
  body.has-mobile-banner .login-form-wrapper-2.forgot,
  body.has-mobile-banner .login-form-wrapper-2.forgotOtp {
    height: calc(100vh - 266px);
  }

  .active-tab-label,
  .active-tab-label-2 {
    margin-bottom: 12px;
  }

  .login-overflow,
  .register-overflow {
    height: calc(100vh - 235px);
    padding: 0 18px;
    overflow: hidden auto;
  }

  body.has-mobile-banner .login-overflow,
  body.has-mobile-banner .register-overflow {
    height: calc(100vh - 295px);
    padding: 0 18px;
  }

  .bussiness-login .login-overflow {
    height: calc(100vh - 215px);
    padding: 0 18px;
  }

  body.has-mobile-banner .bussiness-login .login-overflow {
    height: calc(100vh - 209px);
    padding: 0 18px;
  }

  .bussiness-login .register-overflow {
    height: calc(100vh - 136px);
    padding: 0 18px;
  }

  body.has-mobile-banner .bussiness-login .register-overflow {
    height: calc(100vh - 200px);
    padding: 0 18px;
  }

  .bussiness-login .login-form-wrapper-2 {
    padding: 23px 25px 25px 25px;
  }

  .bussiness-login .login-form-wrapper-2.reset,
  .bussiness-login .login-form-wrapper-2.forgot,
  .bussiness-login .login-form-wrapper-2.forgotOtp {
    height: calc(100vh - 72px);
  }

  body.has-mobile-banner .bussiness-login .login-form-wrapper-2.reset,
  body.has-mobile-banner .bussiness-login .login-form-wrapper-2.forgot,
  body.has-mobile-banner .bussiness-login .login-form-wrapper-2.forgotOtp {
    height: calc(100vh - 136px);
    padding: 0 18px;
  }
}

/* Custom Mobile Login Screen Styles */
.mobile-login-screen {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background: #ffffff !important;
  display: flex;
  flex-direction: column;
}

.mobile-overlay-wrapper,
.mobile-overlay-wrapper > div {
  flex-grow: 1 !important;
  display: flex !important;
  flex-direction: column !important;
}

.mobile-overlay-wrapper .b-overlay {
  border-radius: 40px 40px 0 0 !important;
  margin-top: -30px !important;
  height: calc(100% + 30px) !important;
}

.mobile-overlay-wrapper .b-overlay .rounded-sm {
  border-radius: 40px 40px 0 0 !important;
}

.mobile-header-panel {
  background-image: url("~@/assets/imgs/newhomepage/header-bg.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 30px 24px 60px 24px;
  position: relative;
}

.mobile-header-panel.business-header-bg {
  background-image: url("~@/assets/imgs/newhomepage/business-header.svg") !important;
}

.header-back-wrapper {
  position: absolute;
  top: 30px;
  left: 20px;
}

.header-back-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.business-header-bg .header-back-icon {
  background: #7a7a7a;
  border-radius: 50% !important;
}

.back-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background 0.2s ease;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.rotated-back-arrow {
  width: 32px;
  height: 32px;
}

.hire3x-round-logo {
  width: 60px;
  height: 60px;
}

.mobile-header-title {
  font-family: "Manrope", sans-serif !important;
  font-weight: 800 !important;
  font-size: 28px !important;
  line-height: 36px !important;
  color: #ffffff !important;
  margin-bottom: 12px !important;
}

.mobile-header-title.business-title {
  color: #2e425d !important;
}

.mobile-header-subtitle {
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  color: #94a3b8 !important;
  margin: 0 !important;
}

.mobile-form-panel {
  background: #ffffff !important;
  border-top-left-radius: 40px !important;
  border-top-right-radius: 40px !important;
  padding: 16px !important;
  margin-top: -30px;
  position: relative;
  z-index: 2;
  flex-grow: 1;
  animation: slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.mobile-form-panel.set-password-padding {
  padding: 24px 16px !important;
}

@keyframes slideUp {
  0% {
    transform: translateY(100%);
    opacity: 0.8;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.mob-toggle-container {
  background: #e8edf5;
  border-radius: 30px;
  padding: 4px;
}

.mob-toggle-btn {
  border: none;
  background: transparent;
  padding: 12px 20px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  border-radius: 26px;
  transition: all 0.3s ease;
}

.mob-toggle-btn.active {
  background: linear-gradient(
    90deg,
    #20639b 0%,
    #2f4691 31.02%,
    #4e2f91 69.64%,
    #7c1585 131.69%
  ) !important;
  color: #ffffff !important;
}

.mob-google-btn {
  background: #ffffff !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 32px !important;
  height: 48px !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  color: #64748b !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05) !important;
}

.mob-separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #757575 !important;
  font-family: "Inter", sans-serif !important;
  font-size: 12px;
  font-weight: 500;
}

.mob-separator::before,
.mob-separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #cbd5e1 !important;
}

.mob-separator:not(:empty)::before {
  margin-right: 0.5em;
}

.mob-separator:not(:empty)::after {
  margin-left: 0.5em;
}

.single-field-update:focus {
  border-color: #4a7eff !important;
  box-shadow: none !important;
  outline: none !important;
}

.mob-toggle-link {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #4a7eff !important;
  text-decoration: none !important;
}

.mob-continue-btn {
  background: #4a7eff !important;
  border: none !important;
  border-radius: 30px !important;
  height: 48px !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  color: #ffffff !important;
  box-shadow: 0px 4px 12px rgba(74, 126, 255, 0.24) !important;
}

.mob-terms-text {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  color: #64748b !important;
  line-height: 18px !important;
}

.mob-terms-link {
  color: #4a7eff !important;
  text-decoration: underline !important;
}

.dummy-figma-box {
  background: #f4f4f4 !important;
  box-shadow: 0px 1px 2px 0px #0000000d !important;
  padding: 15px 20px !important;
  border-radius: 30px !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.dummy-email-text {
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #1f1f1f !important;
}

.dummy-edit-btn {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #4a7eff !important;
  text-decoration: none !important;
}

.dummy-edit-btn:hover {
  text-decoration: underline !important;
}

/* Edit overlay positioned inside email input — mobile */
.mob-email-edit-overlay {
  position: absolute !important;
  right: 16px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 3 !important;
  font-size: 12px !important;
}

/* Edit button inside email input — desktop */
.desktop-email-edit-btn {
  position: absolute !important;
  right: 16px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 3 !important;
  font-family: "Inter", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #4a7eff !important;
  text-decoration: none !important;
  cursor: pointer !important;
}

.desktop-email-edit-btn:hover {
  text-decoration: underline !important;
}

.mobile-set-password-container {
  display: flex !important;
  flex-direction: column !important;
}

.mobile-set-password-title {
  font-family: "Poppins", sans-serif !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #1f1f1f !important;
  margin-bottom: 8px !important;
  margin-top: 0px !important;
}

.mobile-set-password-subtitle {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #667085 !important;
  margin-bottom: 24px !important;
  line-height: 20px !important;
}

.mob-sent-info-box {
  background: linear-gradient(
    90deg,
    rgba(74, 126, 255, 0.06) 0%,
    rgba(0, 38, 134, 0.06) 100%
  );
  box-shadow: 0px 1px 2px 0px #0000000d !important;
  padding: 15px 20px !important;
  border-radius: 40px !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.mob-sent-label {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #667085 !important;
}

.mob-sent-email {
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #1f1f1f !important;
}

.mob-sent-edit-btn {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #4a7eff !important;
  text-decoration: underline !important;
}

.mobile-fields-container {
  display: flex !important;
  flex-direction: column !important;
}

.mob-resend-container {
  font-family: "Inter", sans-serif !important;
  font-size: 13px !important;
  color: #757575 !important;
  text-align: right !important;
  margin-top: -8px !important;
}

.mob-resend-link {
  color: #008000 !important;
  font-weight: 600 !important;
}

.dummy-complete-signup-container {
  display: flex !important;
  flex-direction: column !important;
}

.dummy-signup-banner {
  background: #e8f1ff !important;
  border-radius: 20px !important;
  padding: 16px 20px !important;
  position: relative !important;
  overflow: hidden !important;
}

.dummy-signup-title {
  font-family: "Poppins", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #1e40af !important;
  line-height: 22px !important;
  margin: 0 !important;
  text-align: left !important;
}

.dummy-banner-avatar {
  width: 55px !important;
  height: 55px !important;
  object-fit: contain !important;
}

.dummy-signup-fields-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
}

.dummy-input-group {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
}

.dummy-input-label {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #475569 !important;
  margin-bottom: 6px !important;
}

.required-star {
  color: #ef4444 !important;
  margin-left: 2px !important;
}

.otp-already-sent-notice {
  font-family: "Inter", sans-serif !important;
  font-size: 13px !important;
  color: #475569 !important;
  background: #f0f7ff !important;
  border: 1px solid #bfdbfe !important;
  border-radius: 8px !important;
  padding: 8px 12px !important;
  line-height: 1.5 !important;
}
.otp-already-sent-notice strong {
  color: #1d4ed8 !important;
  font-weight: 600 !important;
}
@media (max-height: 650px) {
  .login-overflow {
    overflow: auto !important;
  }
}
.login-overflow.has-errors {
  overflow: auto !important;
}

@media (max-width: 767px) {
  .mobile-login-screen input,
  .mobile-login-screen select,
  .mobile-login-screen textarea,
  .mobile-login-screen .form-control {
    font-size: 16px !important;
  }
}

.otp-links-container a {
  text-decoration: underline !important;
}
</style>
